module.exports = __webpack_public_path__ + "img/checked-favor.b250e760.svg";